import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import api from './request/api/index'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueWechatTitle)
Vue.prototype.$api = api

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
